<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      class="header-menu"
      :class="$mq"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
          v-bind="attrs"
          v-on="on"
      >
        <i class="nv nv-navigation-drawer nv-4x nv-fw" />
      </span>
    </template>
    <v-card class="background-menu">
      <v-card-actions class="close-menu">
        <v-btn
          text
          @click="menu = false"
        >
          <i class="us us-times us-2x us-fw" />
        </v-btn>
      </v-card-actions>
      <connect/>
      <v-divider></v-divider>
      <tabs/>
    </v-card>
  </v-menu>
</template>

<script>
import connect from "./connect"
import tabs from "./tabs"

export default {
  name: "menuHeader",

  components: {
    connect,
    tabs,
  },

  data: () => ({
    menu: false,
  })
}
</script>

<style lang="scss">
@import "../../utilities/variables";

.close-menu {
  display: flex;
  justify-content: flex-end;
}

.background-menu {
  padding: 10px 0;
}

.header-menu.smartphone {
  display: flex;
}

.header-menu.computer {
  display: none;
}
</style>
